

















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class Live extends Vue {
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'live',
        styleType: 0,
        imgUrl: [
          {
            img: null,
            url: null,
          },
        ],
      }
    },
  })
  LiveConfig!: any

  //选择的图片下标
  selectIndex = 0

  styleList = [
    { img: require('@/assets/images/picture-1.jpg'), title: '1张图', num: 1 },
    // { img: require('@/assets/images/picture-2.jpg'), title: '2张图', num: 2 },
    // { img: require('@/assets/images/picture-3.jpg'), title: '3张图', num: 3 },
    // { img: require('@/assets/images/picture-4.jpg'), title: '4张图', num: 4 },
    // { img: require('@/assets/images/picture-5.jpg'), title: '2张平分', num: 2 },
    // { img: require('@/assets/images/picture-6.jpg'), title: '3张平分', num: 3 },
    // {
    //   img: require('@/assets/images/picture-7.png'),
    //   title: '4张左右平分',
    //   num: 4
    // },
    // {
    //   img: require('@/assets/images/picture-8.jpg'),
    //   title: '4张上下平分',
    //   num: 4
    // }
  ]


  get imgObj() {
    return this.LiveConfig.imgUrl[this.selectIndex]
  }

  mounted() {}

  /**
   * 样式更改
   */
  styleChange(row, index) {
    this.LiveConfig.styleType = index
    if (this.LiveConfig.imgUrl.length < row.num) {
      let len = row.num - this.LiveConfig.imgUrl.length
      for (let i = 0; i < len; i++) {
        let obj = {
          img: null,
          url: null,
        }
        this.LiveConfig.imgUrl.push(obj)
      }
    } else if (this.LiveConfig.imgUrl.length > row.num) {
      let len = this.LiveConfig.imgUrl.length - row.num
      this.LiveConfig.imgUrl.splice(row.num, len)
    }
    this.selectIndex = 0
  }

  /**
   * 选择图片
   */
  picChange(e) {
    this.LiveConfig.imgUrl[this.selectIndex]['img'] = e[0].url
  }

  urlChange(e) {
    this.imgObj.url = e
  }

  /**
   * 选择虚线框
   */
  selectChange(index) {
    this.selectIndex = index
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.LiveConfig.imgUrl.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      img: null,
      url: null,
    }
    this.LiveConfig.imgUrl.push(obj)
  }
}
